import { IRoute } from '../../types';
import Login from './Login';

const ROUTES: IRoute[] = [
  {
    path: '/*',
    to: '/*',
    label: 'login',
    element: <Login />,
    index: true,
  },
];

export default ROUTES;
